<template>
  <v-dialog v-model="show" max-width="400px">
    <v-card class="rounded-xl border border-white-05 bg-surface">
      <v-card-title class="text-h5 font-weight-black pa-6">
        {{ editingDiscover ? 'Edit Search' : 'Add Custom Search' }}
      </v-card-title>
      
      <v-card-text class="pa-6 pt-0">
        <v-text-field
          v-model="form.name"
          label="Display Name"
          placeholder="e.g. Unity Devs"
          variant="outlined"
          density="comfortable"
          class="mb-4"
          hide-details
        ></v-text-field>
        
        <v-text-field
          v-model="form.query"
          label="Search Query"
          placeholder="e.g. #unity #gamedev"
          variant="outlined"
          density="comfortable"
          hide-details
        ></v-text-field>
        <div class="text-caption text-grey mt-2">
          You can use hashtags or regular keywords.
        </div>
      </v-card-text>
      
      <v-card-actions class="pa-6 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          class="font-weight-bold"
          @click="show = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          class="rounded-pill font-weight-bold px-6"
          :disabled="!isValid"
          @click="handleSave"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import type { CustomDiscover } from '@/services/bluesky';

const props = defineProps<{
  modelValue: boolean;
  editingDiscover?: CustomDiscover | null;
}>();

const emit = defineEmits(['update:modelValue', 'save']);

const show = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const form = ref({
  name: '',
  query: ''
});

const isValid = computed(() => {
  return form.value.name.trim().length > 0 && form.value.query.trim().length > 0;
});

watch(() => props.editingDiscover, (newVal) => {
  if (newVal) {
    form.value = { ...newVal };
  } else {
    form.value = { name: '', query: '' };
  }
}, { immediate: true });

const handleSave = () => {
  if (!isValid.value) return;
  emit('save', {
    ...form.value,
    id: props.editingDiscover?.id || Math.random().toString(36).substring(2, 9)
  });
  show.value = false;
};
</script>
